import React, { useState, useEffect } from 'react'

import CardStructure from 'components/index/CardStructure'
import Layout from 'global/layout/Layout'
import SEO from 'global/layout/Seo'

import './Category.scss'
import Pagination from 'templates/components/Pagination'
import { taxonomyClassNames } from 'util/misc'
import { graphql } from 'gatsby'

import { getFeaturedBreaks } from 'services/break'

const getShellCard = () => {
  return {
    isLoading: true,
    permalink: undefined,
    title: undefined,
    heroImageUrl: undefined,
    featuredImageUrl: undefined,
    step_types: undefined,
    sponsored: undefined,
    points: undefined,
  }
}

const CategoryTemplate = ({
  data,
  pageContext: { currentPage, numPages, categorySlug, categoryLabel },
}) => {
  const [featuredBreaks, updatedFeaturedBreaks] = useState([])

  const pageTitle = data.site.siteMetadata.title + ' | ' + categoryLabel

  useEffect(() => {
    const retrieveFeaturedBreaks = async data => {
      try {
        const response = await getFeaturedBreaks({
          limit: 4,
          sponsoredOnly: false,
        })
        updatedFeaturedBreaks(response.detail)
      } catch (e) {
        updatedFeaturedBreaks([])
      }
    }

    if (currentPage === 1) {
      updatedFeaturedBreaks(Array.from(Array(4), () => getShellCard()))
      retrieveFeaturedBreaks()
    }
  }, [currentPage, updatedFeaturedBreaks])

  const breaks = [...featuredBreaks, ...data.recent.nodes]

  return (
    <Layout>
      <main className={taxonomyClassNames(currentPage, categorySlug)}>
        <SEO title={pageTitle} />
        <section className="section section-break">
          <div className="container">
            <div className="row">
              <CardStructure
                breaks={breaks}
                tag={categorySlug}
                sectionTitle={categoryLabel}
                showAll={true}
              />
            </div>
          </div>
          <Pagination
            currentPage={currentPage}
            numPages={numPages}
            baseSlug={`tag/${categorySlug}`}
          />
        </section>
      </main>
    </Layout>
  )
}

// skip, limit, category_key get passed in via context in createPage() call
export const pageQuery = graphql`
  query pageQuery(
    $skip: Int!
    $limit: Int!
    $category_key: String!
    $lang: String!
  ) {
    site {
      siteMetadata {
        title
      }
    }
    recent: allBreak(
      skip: $skip
      limit: $limit
      sort: {order: DESC, fields: displayDateEpoch}
      filter: {
        categories: { eq: $category_key }
        lang: { eq: $lang }
        isSponsored: { eq: false }
        hideOnHomepage: { eq: false }
      }
    ) {
      nodes {
        displayDateEpoch
        featuredImageUrl
        heroImageUrl
        permalink
        title
        step_types
        points
        id
      }
    }
  }
`

export default CategoryTemplate
